/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserRole, UserSubRole } from "../app/services/userApi";
import { RootState } from "../app/store";

type hwbMeta = {
  name: string;
  sub: string;
  given_name: string;
  family_name: string;
  picture: string;
  email: string;
};

type userMeta = {
  name: string;
  lastLogin: string;
  avatar: string;
  uuid: string;
  hwb?: hwbMeta;
};

export type User = {
  PK: string;
  SK: string;
  role: UserRole;
  subRole: UserSubRole;
  email: string;
  emailHash: string;
  meta: userMeta;
  termsConditions?: string;
};

export interface AuthState {
  isPending: boolean; // tracks the state of the getUser query
  userInfo?: User; // can be used to get any needed user information, such as role
  isAuthenticated: boolean; // is true if the user's token successfully got a user account
  isStaff: boolean; // based on the user's roles
  isTeacher: boolean; // based on the user's roles
}

const initialState: AuthState = {
  isPending: true,
  userInfo: undefined,
  isAuthenticated: false,
  isStaff: false,
  isTeacher: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserPending(state, action: PayloadAction<boolean>) {
      state.isPending = action.payload;
    },

    setUserInfo(state, action: PayloadAction<User>) {
      state.userInfo = action.payload;

      state.isAuthenticated = true;
      state.isStaff = action.payload.role === "wjec";
      state.isTeacher = action.payload.role === "teacher";
    },
    signUserOut(state) {
      state.userInfo = undefined;
      state.isAuthenticated = false;
      state.isStaff = false;
      state.isTeacher = false;
    },
  },
});

export const { setUserPending, setUserInfo, signUserOut } = authSlice.actions;
export const getUserInfo = (state: RootState) => state.auth.userInfo;
export default authSlice.reducer;
